import 'twin.macro';
import React from 'react';
import { useUser } from '@teetsh/app/src/containers/App/context/useUser';
import useUpdateUser from '@teetsh/app/src/queries/user/useUpdateUser';
import useNotification from '@teetsh/app/src/containers/App/Notifications/useNotification';
import Cards from '@teetsh/app/src/components/RadioGroups/Cards';
import { useTranslation } from 'react-i18next';

export function CondensedOption() {
  const user = useUser();
  const { notifyError } = useNotification();
  const { t } = useTranslation(['common', 'cahierJournal', 'referentiel']);
  const updateUser = useUpdateUser();
  const condensed = user?.fonts?.cj?.condensed;
  const onUpdateCondensed = (c: boolean) =>
    updateUser({
      ...user,
      fonts: {
        ...user.fonts,
        cj: {
          ...user.fonts.cj,
          condensed: c,
        },
      },
    }).catch(() => notifyError({ title: t('common:messages.genericError') }));

  return (
    <Cards
      label={t('cahierJournal:settings.seanceStructure.title')}
      cols="2"
      options={[
        {
          value: '1col',
          title: t('cahierJournal:settings.seanceStructure.1col'),
          description: (
            <div tw="p-3">
              <div tw="flex">
                <div tw="rounded border-2 h-32 text-xs p-1">
                  <div>{t('referentiel:type.matiere')} : ...</div>
                  <div>{t('referentiel:type.domaine')} : ...</div>
                  <div>...</div>
                  <div>{t('cahierJournal:seance.flow')}</div>
                  <div>...</div>
                </div>
              </div>
            </div>
          ),
        },
        {
          value: '2cols',
          title: t('cahierJournal:settings.seanceStructure.2col'),
          description: (
            <div tw="p-3">
              <div tw="flex">
                <div tw="rounded border-2 h-32 text-xs p-1">
                  <div>{t('referentiel:type.matiere')} : ...</div>
                  <div>{t('referentiel:type.domaine')} : ...</div>
                  <div>...</div>
                </div>
                <div tw="rounded border-b-2 border-r-2 border-t-2 text-xs h-32 p-1">
                  <div>{t('cahierJournal:seance.flow')}</div>
                  <div>...</div>
                </div>
              </div>
            </div>
          ),
        },
      ]}
      value={condensed ? '2cols' : '1col'}
      onChange={value => onUpdateCondensed(value === '2cols')}
    />
  );
}
